"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class ExponentialBackOffTokenRefillStrategy {
    constructor(backOffExponentMutex, backOffMultiplier, minDelayInMilliseconds, maxDelayInMilliseconds) {
        this.backOffExponent = 0;
        this.backOffExponentMutex = backOffExponentMutex;
        this.backOffMultiplier = backOffMultiplier;
        this.minDelayInMilliseconds = minDelayInMilliseconds;
        this.maxDelayInMilliseconds = maxDelayInMilliseconds;
        this.maxBackOffExponent = Math.ceil(Math.log(maxDelayInMilliseconds / minDelayInMilliseconds) / Math.log(backOffMultiplier));
    }
    getNextTokenRefillDelay() {
        return Math.min(this.maxDelayInMilliseconds, this.minDelayInMilliseconds * Math.pow(this.backOffMultiplier, (this.backOffExponent)));
    }
    reportSuccess() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.backOffExponentMutex
                .runExclusive(() => {
                this.backOffExponent = Math.max(0, this.backOffExponent - 1);
            });
        });
    }
    reportFailure() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.backOffExponentMutex
                .runExclusive(() => {
                this.backOffExponent = Math.min(this.maxBackOffExponent, this.backOffExponent + 1);
            });
        });
    }
}
exports.default = ExponentialBackOffTokenRefillStrategy;
